"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _constants = require("../constants");
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */
/**
 * IInMeetingActions
 * Type for In-Meeting Actions
 */
/**
 * @class InMeetingActions
 */
var InMeetingActions = exports.default = /*#__PURE__*/(0, _createClass2.default)(function InMeetingActions() {
  var _this = this;
  (0, _classCallCheck2.default)(this, InMeetingActions);
  (0, _defineProperty2.default)(this, "namespace", _constants.MEETINGS);
  (0, _defineProperty2.default)(this, "canInviteNewParticipants", null);
  (0, _defineProperty2.default)(this, "canAdmitParticipant", null);
  (0, _defineProperty2.default)(this, "canLock", null);
  (0, _defineProperty2.default)(this, "canUnlock", null);
  (0, _defineProperty2.default)(this, "canAssignHost", null);
  (0, _defineProperty2.default)(this, "canStartRecording", null);
  (0, _defineProperty2.default)(this, "canPauseRecording", null);
  (0, _defineProperty2.default)(this, "canResumeRecording", null);
  (0, _defineProperty2.default)(this, "isPremiseRecordingEnabled", null);
  (0, _defineProperty2.default)(this, "canStopRecording", null);
  (0, _defineProperty2.default)(this, "canSetMuteOnEntry", null);
  (0, _defineProperty2.default)(this, "canSetPresenter", null);
  (0, _defineProperty2.default)(this, "canUnsetPresenter", null);
  (0, _defineProperty2.default)(this, "canUnsetMuteOnEntry", null);
  (0, _defineProperty2.default)(this, "canSetDisallowUnmute", null);
  (0, _defineProperty2.default)(this, "canUnsetDisallowUnmute", null);
  (0, _defineProperty2.default)(this, "canSetMuted", null);
  (0, _defineProperty2.default)(this, "canUnsetMuted", null);
  (0, _defineProperty2.default)(this, "canRaiseHand", null);
  (0, _defineProperty2.default)(this, "canLowerAllHands", null);
  (0, _defineProperty2.default)(this, "canLowerSomeoneElsesHand", null);
  (0, _defineProperty2.default)(this, "bothLeaveAndEndMeetingAvailable", null);
  (0, _defineProperty2.default)(this, "canEnableClosedCaption", null);
  (0, _defineProperty2.default)(this, "canStartTranscribing", null);
  (0, _defineProperty2.default)(this, "canStopTranscribing", null);
  (0, _defineProperty2.default)(this, "isClosedCaptionActive", null);
  (0, _defineProperty2.default)(this, "canStartManualCaption", null);
  (0, _defineProperty2.default)(this, "canStopManualCaption", null);
  (0, _defineProperty2.default)(this, "isManualCaptionActive", null);
  (0, _defineProperty2.default)(this, "isSaveTranscriptsEnabled", null);
  (0, _defineProperty2.default)(this, "isWebexAssistantActive", null);
  (0, _defineProperty2.default)(this, "canViewCaptionPanel", null);
  (0, _defineProperty2.default)(this, "isRealTimeTranslationEnabled", null);
  (0, _defineProperty2.default)(this, "canSelectSpokenLanguages", null);
  (0, _defineProperty2.default)(this, "waitingForOthersToJoin", null);
  (0, _defineProperty2.default)(this, "canSendReactions", null);
  (0, _defineProperty2.default)(this, "canManageBreakout", null);
  (0, _defineProperty2.default)(this, "canBroadcastMessageToBreakout", null);
  (0, _defineProperty2.default)(this, "canAdmitLobbyToBreakout", null);
  (0, _defineProperty2.default)(this, "isBreakoutPreassignmentsEnabled", null);
  (0, _defineProperty2.default)(this, "canUserAskForHelp", null);
  (0, _defineProperty2.default)(this, "canUserRenameSelfAndObserved", null);
  (0, _defineProperty2.default)(this, "canUserRenameOthers", null);
  (0, _defineProperty2.default)(this, "canMuteAll", null);
  (0, _defineProperty2.default)(this, "canUnmuteAll", null);
  (0, _defineProperty2.default)(this, "canEnableHardMute", null);
  (0, _defineProperty2.default)(this, "canDisableHardMute", null);
  (0, _defineProperty2.default)(this, "canEnableMuteOnEntry", null);
  (0, _defineProperty2.default)(this, "canDisableMuteOnEntry", null);
  (0, _defineProperty2.default)(this, "canEnableReactions", null);
  (0, _defineProperty2.default)(this, "canDisableReactions", null);
  (0, _defineProperty2.default)(this, "canEnableReactionDisplayNames", null);
  (0, _defineProperty2.default)(this, "canDisableReactionDisplayNames", null);
  (0, _defineProperty2.default)(this, "canUpdateShareControl", null);
  (0, _defineProperty2.default)(this, "canEnableViewTheParticipantsList", null);
  (0, _defineProperty2.default)(this, "canDisableViewTheParticipantsList", null);
  (0, _defineProperty2.default)(this, "canEnableViewTheParticipantsListPanelist", null);
  (0, _defineProperty2.default)(this, "canDisableViewTheParticipantsListPanelist", null);
  (0, _defineProperty2.default)(this, "canEnableShowAttendeeCount", null);
  (0, _defineProperty2.default)(this, "canDisableShowAttendeeCount", null);
  (0, _defineProperty2.default)(this, "canEnableRaiseHand", null);
  (0, _defineProperty2.default)(this, "canDisableRaiseHand", null);
  (0, _defineProperty2.default)(this, "canEnableVideo", null);
  (0, _defineProperty2.default)(this, "canDisableVideo", null);
  (0, _defineProperty2.default)(this, "canShareFile", null);
  (0, _defineProperty2.default)(this, "canShareApplication", null);
  (0, _defineProperty2.default)(this, "canShareCamera", null);
  (0, _defineProperty2.default)(this, "canShareDesktop", null);
  (0, _defineProperty2.default)(this, "canShareContent", null);
  (0, _defineProperty2.default)(this, "canTransferFile", null);
  (0, _defineProperty2.default)(this, "canChat", null);
  (0, _defineProperty2.default)(this, "canDoVideo", null);
  (0, _defineProperty2.default)(this, "canAnnotate", null);
  (0, _defineProperty2.default)(this, "canUseVoip", null);
  (0, _defineProperty2.default)(this, "supportHQV", null);
  (0, _defineProperty2.default)(this, "enforceVirtualBackground", null);
  (0, _defineProperty2.default)(this, "supportHDV", null);
  (0, _defineProperty2.default)(this, "canShareWhiteBoard", null);
  (0, _defineProperty2.default)(this, "canPollingAndQA", null);
  (0, _defineProperty2.default)(this, "canStartWebcast", null);
  (0, _defineProperty2.default)(this, "canStopWebcast", null);
  (0, _defineProperty2.default)(this, "canShowStageView", null);
  (0, _defineProperty2.default)(this, "canEnableStageView", null);
  (0, _defineProperty2.default)(this, "canDisableStageView", null);
  (0, _defineProperty2.default)(this, "isPracticeSessionOn", null);
  (0, _defineProperty2.default)(this, "isPracticeSessionOff", null);
  (0, _defineProperty2.default)(this, "canStartPracticeSession", null);
  (0, _defineProperty2.default)(this, "canStopPracticeSession", null);
  /**
   * Returns all meeting action options
   * @returns {Object}
   */
  (0, _defineProperty2.default)(this, "get", function () {
    return {
      canInviteNewParticipants: _this.canInviteNewParticipants,
      canAdmitParticipant: _this.canAdmitParticipant,
      canLock: _this.canLock,
      canUnlock: _this.canUnlock,
      canAssignHost: _this.canAssignHost,
      canSetMuteOnEntry: _this.canSetMuteOnEntry,
      canUnsetMuteOnEntry: _this.canUnsetMuteOnEntry,
      canSetDisallowUnmute: _this.canSetDisallowUnmute,
      canSetMuted: _this.canSetMuted,
      canUnsetMuted: _this.canUnsetMuted,
      canSetPresenter: _this.canSetPresenter,
      canUnsetPresenter: _this.canUnsetPresenter,
      canUnsetDisallowUnmute: _this.canUnsetDisallowUnmute,
      canStartRecording: _this.canStartRecording,
      canPauseRecording: _this.canPauseRecording,
      canResumeRecording: _this.canResumeRecording,
      canStopRecording: _this.canStopRecording,
      isPremiseRecordingEnabled: _this.isPremiseRecordingEnabled,
      canRaiseHand: _this.canRaiseHand,
      canLowerAllHands: _this.canLowerAllHands,
      canLowerSomeoneElsesHand: _this.canLowerSomeoneElsesHand,
      bothLeaveAndEndMeetingAvailable: _this.bothLeaveAndEndMeetingAvailable,
      canEnableClosedCaption: _this.canEnableClosedCaption,
      canStartTranscribing: _this.canStartTranscribing,
      canStopTranscribing: _this.canStopTranscribing,
      isClosedCaptionActive: _this.isClosedCaptionActive,
      canStartManualCaption: _this.canStartManualCaption,
      canStopManualCaption: _this.canStopManualCaption,
      isManualCaptionActive: _this.isManualCaptionActive,
      isSaveTranscriptsEnabled: _this.isSaveTranscriptsEnabled,
      isWebexAssistantActive: _this.isWebexAssistantActive,
      canViewCaptionPanel: _this.canViewCaptionPanel,
      isRealTimeTranslationEnabled: _this.isRealTimeTranslationEnabled,
      canSelectSpokenLanguages: _this.canSelectSpokenLanguages,
      waitingForOthersToJoin: _this.waitingForOthersToJoin,
      canSendReactions: _this.canSendReactions,
      canManageBreakout: _this.canManageBreakout,
      canBroadcastMessageToBreakout: _this.canBroadcastMessageToBreakout,
      canAdmitLobbyToBreakout: _this.canAdmitLobbyToBreakout,
      isBreakoutPreassignmentsEnabled: _this.isBreakoutPreassignmentsEnabled,
      canUserAskForHelp: _this.canUserAskForHelp,
      canUserRenameSelfAndObserved: _this.canUserRenameSelfAndObserved,
      canUserRenameOthers: _this.canUserRenameOthers,
      canMuteAll: _this.canMuteAll,
      canUnmuteAll: _this.canUnmuteAll,
      canEnableHardMute: _this.canEnableHardMute,
      canDisableHardMute: _this.canDisableHardMute,
      canEnableMuteOnEntry: _this.canEnableMuteOnEntry,
      canDisableMuteOnEntry: _this.canDisableMuteOnEntry,
      canEnableReactions: _this.canEnableReactions,
      canDisableReactions: _this.canDisableReactions,
      canEnableReactionDisplayNames: _this.canEnableReactionDisplayNames,
      canDisableReactionDisplayNames: _this.canDisableReactionDisplayNames,
      canUpdateShareControl: _this.canUpdateShareControl,
      canEnableViewTheParticipantsList: _this.canEnableViewTheParticipantsList,
      canDisableViewTheParticipantsList: _this.canDisableViewTheParticipantsList,
      canEnableViewTheParticipantsListPanelist: _this.canEnableViewTheParticipantsListPanelist,
      canDisableViewTheParticipantsListPanelist: _this.canDisableViewTheParticipantsListPanelist,
      canEnableShowAttendeeCount: _this.canEnableShowAttendeeCount,
      canDisableShowAttendeeCount: _this.canDisableShowAttendeeCount,
      canEnableRaiseHand: _this.canEnableRaiseHand,
      canDisableRaiseHand: _this.canDisableRaiseHand,
      canEnableVideo: _this.canEnableVideo,
      canDisableVideo: _this.canDisableVideo,
      canShareFile: _this.canShareFile,
      canShareApplication: _this.canShareApplication,
      canShareCamera: _this.canShareCamera,
      canShareDesktop: _this.canShareDesktop,
      canShareContent: _this.canShareContent,
      canTransferFile: _this.canTransferFile,
      canChat: _this.canChat,
      canDoVideo: _this.canDoVideo,
      canAnnotate: _this.canAnnotate,
      canUseVoip: _this.canUseVoip,
      enforceVirtualBackground: _this.enforceVirtualBackground,
      supportHQV: _this.supportHQV,
      supportHDV: _this.supportHDV,
      canShareWhiteBoard: _this.canShareWhiteBoard,
      canPollingAndQA: _this.canPollingAndQA,
      canStartWebcast: _this.canStartWebcast,
      canStopWebcast: _this.canStopWebcast,
      canShowStageView: _this.canShowStageView,
      canEnableStageView: _this.canEnableStageView,
      canDisableStageView: _this.canDisableStageView,
      isPracticeSessionOn: _this.isPracticeSessionOn,
      isPracticeSessionOff: _this.isPracticeSessionOff,
      canStartPracticeSession: _this.canStartPracticeSession,
      canStopPracticeSession: _this.canStopPracticeSession
    };
  });
  /**
   *
   * @param actions
   * @returns
   */
  (0, _defineProperty2.default)(this, "set", function (actions) {
    var old = _this.get();
    var changed = false;
    (0, _keys.default)(old).forEach(function (actionKey) {
      var actionValue = actions[actionKey];
      if (actionValue !== undefined && actionValue !== old[actionKey]) {
        changed = true;
        _this[actionKey] = actionValue;
      }
    });
    return changed;
  });
});
//# sourceMappingURL=in-meeting-actions.js.map
